import React, { useState, useEffect } from 'react';
import { ref, get, remove } from 'firebase/database';
import { deleteImmagine } from '../../utils/cloudinaryUtils';
import { database } from '../../firebase/config';
import { formattaData } from '../../utils/dateUtils';

function VisualizzaBolle({ dipendente, onClose }) {
  const [bolle, setBolle] = useState([]);
  const [cantieri, setCantieri] = useState([]);
  const [clienti, setClienti] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fotoSelezionata, setFotoSelezionata] = useState(null);
  const [filtroData, setFiltroData] = useState('');
  const [messaggioCancellazione, setMessaggioCancellazione] = useState('');

  useEffect(() => {
    caricaDati();
  }, [dipendente]);

  async function caricaDati() {
    setLoading(true);
    const [bolleSnap, cantSnap, cliSnap] = await Promise.all([
      get(ref(database, 'bolle')),
      get(ref(database, 'cantieri')),
      get(ref(database, 'clienti')),
    ]);
    if (cantSnap.exists()) {
      setCantieri(Object.keys(cantSnap.val()).map(k => ({ id: k, ...cantSnap.val()[k] })));
    }
    if (cliSnap.exists()) {
      setClienti(Object.keys(cliSnap.val()).map(k => ({ id: k, ...cliSnap.val()[k] })));
    }
    if (bolleSnap.exists()) {
      const tutte = Object.keys(bolleSnap.val()).map(k => ({ id: k, ...bolleSnap.val()[k] }));
      const delDipendente = tutte
        .filter(b => b.dipendenteId === dipendente.id)
        .sort((a, b) => b.createdAt - a.createdAt);
      setBolle(delDipendente);
    }
    setLoading(false);
  }

  function getCantiere(id) {
    return cantieri.find(c => c.id === id);
  }

  function getCliente(cantiereId) {
    const cantiere = getCantiere(cantiereId);
    if (!cantiere) return null;
    return clienti.find(c => c.id === cantiere.clienteId);
  }

  const bolleFiltrate = filtroData
    ? bolle.filter(b => b.data === filtroData)
    : bolle;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content modal-large"
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2>
            📄 Bolle — {dipendente.nome} {dipendente.cognome}
          </h2>
                            <button 
                onClick={onClose}
                style={{
                  background: '#e74c3c',
                  border: 'none',
                  color: 'white',
                  padding: '8px 15px',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '18px',
                  marginRight: '0px',
                  height: 'fit-content'
                }}
              >
                ✕
              </button>
        </div>

        {/* Filtro per data */}
        <div style={{ padding: '16px 24px', borderBottom: '1px solid #dee2e6' }}>
          <label style={{ marginRight: 8, fontWeight: 600 }}>Filtra per data:</label>
          <input
            type="date"
            value={filtroData}
            onChange={e => setFiltroData(e.target.value)}
          />
          {filtroData && (
            <button
              onClick={() => setFiltroData('')}
              style={{ marginLeft: 8, cursor: 'pointer', color: '#e74c3c', border: 'none', background: 'none', fontWeight: 700 }}
            >
              ✕ Rimuovi filtro
            </button>
          )}
        </div>

      {messaggioCancellazione && (
        <div style={{ margin: '12px 24px 0', padding: '8px 12px', background: '#eaffea', color: 'green', fontWeight: 600, borderRadius: 6 }}>
          {messaggioCancellazione}
        </div>
      )}


        <div style={{ padding: 24, overflowY: 'auto', maxHeight: '65vh' }}>
          {loading ? (
            <p>Caricamento...</p>
          ) : bolleFiltrate.length === 0 ? (
            <p style={{ color: '#7f8c8d' }}>
              {filtroData ? `Nessuna bolla per il ${formattaData(filtroData)}` : 'Nessuna bolla caricata'}
            </p>
          ) : (
            <>
              <p style={{ color: '#7f8c8d', marginBottom: 16 }}>
                {bolleFiltrate.length} {bolleFiltrate.length === 1 ? 'bolla' : 'bolle'}
              </p>
              <div className="foto-grid">
                {bolleFiltrate.map(b => {
                  const cantiere = getCantiere(b.cantiereId);
                  const cliente = getCliente(b.cantiereId);
                  return (
                    <div
                      key={b.id}
                      className="foto-item"
                      style={{ cursor: 'pointer' }}
                      onClick={() => setFotoSelezionata(b)}
                    >
                      <img src={b.imageUrl} alt="Bolla" className="foto-thumb" />
                      <small>{formattaData(b.data)}</small>
                      <small>{cantiere?.luogo || 'N/D'}</small>
                      <small style={{ color: '#2c3e50', fontWeight: 600 }}>
                        {cliente?.ragioneSociale || ''}
                      </small>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>
      </div>

      {/* Lightbox foto ingrandita */}
      {fotoSelezionata && (
        <div
          className="modal-overlay"
          style={{ zIndex: 1100 }}
          onClick={() => setFotoSelezionata(null)}
        >
          <div
            className="modal-content"
            style={{ maxWidth: 700, textAlign: 'center' }}
            onClick={e => e.stopPropagation()}
          >
            <div className="modal-header">
              <h3>
                {formattaData(fotoSelezionata.data)} —{' '}
                {getCantiere(fotoSelezionata.cantiereId)?.luogo || 'N/D'}
              </h3>
              <button className="modal-close" onClick={() => setFotoSelezionata(null)}>✕</button>
            </div>
            <img
              src={fotoSelezionata.imageUrl}
              alt="Bolla"
              style={{ width: '100%', borderRadius: 8, marginTop: 12 }}
            />
                        <a
              href={fotoSelezionata.imageUrl}
              download
              target="_blank"
              rel="noreferrer"
              style={{ display: 'inline-block', marginTop: 12, color: '#667eea', fontWeight: 600 }}
            >
              ⬇️ Scarica foto
            </a>
            <button onClick={async () => {
              if (!window.confirm('Sei sicuro di voler cancellare definitivamente questa foto?')) return;
              try {
                await deleteImmagine(fotoSelezionata.publicId);
              } catch (e) {
                console.warn('Cloudinary non raggiunto', e.message);
              }
              try {
                await remove(ref(database, `bolle/${fotoSelezionata.id}`));
                setFotoSelezionata(null);
                await caricaDati();
                setMessaggioCancellazione('Foto cancellata con successo!');
                setTimeout(() => setMessaggioCancellazione(''), 3000);
              } catch (e) {
                alert('Errore durante la cancellazione: ' + e.message);
              }
            }} style={{ display: 'inline-block', marginTop: 12, marginLeft: 12, background: '#e74c3c', color: '#fff', border: 'none', padding: '8px 14px', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}>
              Cancella foto
            </button>
          </div>
        </div>
      )}
    </div>

  );
}

export default VisualizzaBolle;
